import type { AlertRule } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteAlertRuleDialogProps {
  rule: AlertRule | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteAlertRuleDialog({
  rule,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteAlertRuleDialogProps) {
  return (
    <Modal open={rule !== null} title="Delete alert rule" onClose={onCancel}>
      <p>
        Delete <strong>{rule?.name}</strong>? Comebye stops evaluating this condition immediately
        and its firing/resolved history goes with it. This can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Deleting…" : "Delete"}
        </Button>
      </div>
    </Modal>
  );
}
